var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-page"},[(_vm.langValue === 'zh-CN')?_c('zh-cn'):_vm._e(),(_vm.langValue === 'zh-HK' || _vm.langValue === 'en')?_c('zh-hk'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }